module.exports = __webpack_public_path__ + "static/media/vendor.7d1f2ce9.png";